import { ifCanPushDatalayer } from './utils/utils.dataLayer.common';

//UCS013
const dataLayerCta = (el = "", location = "", linkUrl = "", dataTracking = "") => {
    dataLayerBus.push({
        event: 'user_interaction',
        event_name: 'interact',
        interaction: {
            click_type: el,
            link_url: linkUrl,
            interaction_location: location,
            data_tracking: dataTracking,
        },
    });
};

const sendClickDataLayer = (e) => {
    let link = '';
    let closestA = e.target.closest('a');
    let closestButton = e.target.closest('button');
    
    link = closestA ? closestA : closestButton ? closestButton : '';

    ifCanPushDatalayer({
        then: () => {
            let location = '';
            let dataTracking = 'None';
            let text = 'No_text';
            let linkUrl = 'None';

            if (link) {
                if (link.href) {
                    linkUrl = link.href;
                }

                if (link.dataset.tracking !== '') {
                    dataTracking = link.dataset.tracking;
                }

                if (link.closest('[data-vue-component]')) {
                    location = link.closest('[data-vue-component]');
                    location = location.dataset.vueComponent.split('/').pop();

                } else if (link.closest('[data-component-file]')) {
                    location = link.closest('[data-component-file]');
                    location = location.dataset.componentFile.split('/').pop().replace('.main', '');

                } else if (link.closest('[id]')) {
                    location = link.closest('[id]')?.id;

                } else if (link.closest('.main > div')){
                    const parentElement = link.closest('.main > div');
                    const attributes = parentElement.getAttributeNames();

                    location = attributes.find(attribute => attribute.startsWith('am-') && attribute !== 'am-color-scheme');
                }

                if (link.innerText) {
                    text = link.innerText.replace(/(\r\n|\n|\r)/gm, '').trim();
                    text = text.split(' ').join('_');
                    text = `CTA_${text}`;
                }

                dataLayerCta(text, location, linkUrl, dataTracking);
            }
        },
    });
}

const dataLayerCtaGlobal = () => {
    document.addEventListener('mousedown',  sendClickDataLayer);
    document.addEventListener('touchstart',  sendClickDataLayer);
};

export { dataLayerCtaGlobal };
